import React from 'react'

const Congrats = (props) => {
    return (
        <div className="_create_page_modal_wrapper _congrats">
            <div className="_create_page_modal">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <h2 className="_create_page_modal_main_title">Congratulations!</h2>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12">
                            <div className="_create_page_modal_l_t">
                                <h4 className="_create_page_modal_l_title">Category</h4>
                                <span className="_create_page_modal_l_cat">Arts</span>
                            </div>
                            <img src="assets/img/modalimg.png" alt="chobi"  className="_create_page_modal_l_img" />
                            <h4 className="_create_page_modal_l_title">Discription</h4>
                            <p className="_create_page_modal_l_txt">It is a long established fact that a reader will be
                                distracted by the readable content of a
                                page when looking at its layout.by accident, sometimes on purpose (injected humour and the
                                like).</p>
                        </div>
                        <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12">
                            <h4 className="_create_page_modal_l_title">Abstract Cube #2000</h4>
                            <ul className="_create_page_modal_r_list">
                                <li className="_create_page_modal_r_list_item">
                                    <img src="assets/img/eth2.svg" alt="chobi"  className="_create_page_modal_r_list_item_img" />
                                    <span className="_create_page_modal_r_list_item_title">27.5 ETH 1/1</span>
                                </li>
                                <li className="_create_page_modal_r_list_item">
                                    <img src="assets/img/binance_small.svg" alt="chobi"  className="_create_page_modal_r_list_item_img" />
                                    <span className="_create_page_modal_r_list_item_title">27.5 BSC 1/1</span>
                                </li>
                                <li className="_create_page_modal_r_list_item">
                                    <img src="assets/img/tron_small.svg" alt="chobi"  className="_create_page_modal_r_list_item_img" />
                                    <span className="_create_page_modal_r_list_item_title">27.5 BSC 1/1</span>
                                </li>
                            </ul>
                            <div className="_create_page_modal_r_btm">
                                <h4 className="_create_page_modal_l_title">Orgin:</h4>
                                <span className="_create_page_modal_r_btm_result">= $ 646,02</span>
                            </div>
                            <div className="_create_page_modal_r_table">
                                <ul className="_create_page_modal_r_table_head">
                                    <li className="_create_page_modal_r_table_heading">Name</li>
                                    <li className="_create_page_modal_r_table_heading">Action</li>
                                    <li className="_create_page_modal_r_table_heading">Date</li>
                                </ul>
                                <ul className="_create_page_modal_r_table_result">
                                    <li className="_create_page_modal_r_table_result_item">User name</li>
                                    <li className="_create_page_modal_r_table_result_item">Created</li>
                                    <li className="_create_page_modal_r_table_result_item">2022-05-06</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <button onClick={()=>props.set(false)} className="_modal_ok_btn" onclick="closeModal()">OK</button>
                </div>
            </div>
        </div>

    )
}

export default Congrats;